export const TOP_POSITION_HOME = 110;
export const TOP_POSITION_SEARCH_RESULTS = 120;
export const MIN_QUERY_LENGTH = 2;
